if (!customElements.get("seo-read-more")) {
  class SeoReadMore extends HTMLElement {
    static get observedAttributes() {
      return ["data-collapsed-height", "data-label-more", "data-label-less"];
    }

    connectedCallback() {
      this._body = this.querySelector("[data-seo-body]");
      this._trigger = this.querySelector("[data-seo-trigger]");
      this._label = this.querySelector(".seo-rm-section__btn-label");

      if (!this._body || !this._trigger) return;

      this._labelMore = this.dataset.labelMore || "Devamını Gör";
      this._labelLess = this.dataset.labelLess || "Daha Az Gör";

      this._checkNecessity();
      this._trigger.addEventListener("click", this._handleClick.bind(this));
    }

    disconnectedCallback() {
      if (this._trigger) {
        this._trigger.removeEventListener(
          "click",
          this._handleClick.bind(this),
        );
      }
    }

    attributeChangedCallback(name, oldVal, newVal) {
      if (oldVal === newVal) return;

      if (name === "data-collapsed-height") {
        this.style.setProperty("--seo-collapsed-h", newVal + "px");
        this._checkNecessity();
      }

      if (name === "data-label-more") {
        this._labelMore = newVal;
        if (!this._isOpen) this._setLabel(newVal);
      }

      if (name === "data-label-less") {
        this._labelLess = newVal;
        if (this._isOpen) this._setLabel(newVal);
      }
    }

    _checkNecessity() {
      const collapsedH = parseInt(this.dataset.collapsedHeight || "96", 10);
      const content = this._body?.querySelector(".seo-rm-section__content");

      if (!content) return;

      requestAnimationFrame(() => {
        const fits = content.scrollHeight <= collapsedH + 8;
        const btnRow = this._trigger?.closest(".seo-rm-section__btn-row");

        if (fits) {
          if (btnRow) btnRow.hidden = true;
          this._body.classList.remove("seo-rm-section__body--collapsed");
          this._body.classList.add("seo-rm-section__body--expanded");
        } else {
          if (btnRow) btnRow.hidden = false;
        }
      });
    }

    _handleClick() {
      this._isOpen ? this._close() : this._open();
    }

    _open() {
      this._isOpen = true;
      this._body.classList.remove("seo-rm-section__body--collapsed");
      this._body.classList.add("seo-rm-section__body--expanded");
      this._trigger.setAttribute("aria-expanded", "true");
      this._setLabel(this._labelLess);
    }

    _close() {
      this._isOpen = false;
      this._body.classList.remove("seo-rm-section__body--expanded");
      this._body.classList.add("seo-rm-section__body--collapsed");
      this._trigger.setAttribute("aria-expanded", "false");
      this._setLabel(this._labelMore);

      const offset = 80;
      const top =
        this.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }

    _setLabel(text) {
      if (this._label) this._label.textContent = text;
    }
  }

  customElements.define("seo-read-more", SeoReadMore);
}
